// extracted by mini-css-extract-plugin
module.exports = {"alignCards":"styles_alignCards__1onP8"};